export default () => {
    if (process.server) return
    if (window.klaviyo) return

    window._klOnsite = window._klOnsite || []
    window.klaviyo = window.klaviyo || []
    const KLAVIYO_PUBLIC_API_KEY = process.env.KLAVIYO_PUBLIC_API_KEY;

    const script = document.createElement('script')
    script.type = 'text/javascript'
    script.async = true;
    script.src =
        `https://static.klaviyo.com/onsite/js/${KLAVIYO_PUBLIC_API_KEY}/klaviyo.js`

    script.onload = () => {
        console.log('Klaviyo loaded')
    }

    document.head.appendChild(script)
}